import React from "react";
import "./BottomFooterModal.css";
import Footer from "../../Footer/Footer";
import { IoClose } from "react-icons/io5";

export default function BottomFooterModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="footer-modal-overlay" onClick={onClose}>
      <div className="footer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="footer-modal-content">
        <button className="footer-close-btn" onClick={onClose}><IoClose color="white" /></button>
         <Footer/>
        </div>
      </div>
    </div>
  );
}
